import React from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import App from './App.tsx'
import './index.css'

// Força React a estar disponível globalmente ANTES de qualquer componente
const globalReact = React;

// Define React no escopo global do window e globalThis
if (typeof window !== 'undefined') {
  (window as any).React = globalReact;
}
if (typeof globalThis !== 'undefined') {
  (globalThis as any).React = globalReact;
}

// Create a client
const queryClient = new QueryClient()

createRoot(document.getElementById("root")!).render(
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>
);